<div class="modal-header">
  <h4 class="modal-title pull-left">
    <app-icon icon="home" iconClass="button-icon"></app-icon>
    <span class="modal-title">Add Organization</span>
  </h4>

  <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.hide()">
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="newHospitalForm">
    <div class="row mb-3">
      <label for="name" class="fw-bold col-sm-3 col-form-label">Name</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" placeholder="Name" formControlName="name">
        @if ((newHospitalForm.get('name').touched || formInvalid) && newHospitalForm.get('name').invalid) {
          <div class="form-error">
            <p>Name cannot be empty.</p>
          </div>
        }
      </div>
    </div>

    <div class="row mb-3">
      <label for="ride-share-buffer" class="fw-bold col-sm-3 col-form-label">Advanced Notice for Ride Share Rides</label>
      <div class="col-sm-9">
        <input type="number" class="form-control" formControlName="advance_notice_for_ride_share_rides" placeholder="0 (in minutes)">
        @if ((newHospitalForm.get('advance_notice_for_ride_share_rides').touched || formInvalid) && newHospitalForm.get('advance_notice_for_ride_share_rides').invalid) {
          <div class="form-error">
            <p>Notice period cannot be empty.</p>
          </div>
        }
        <p class="small">
          The Advanced Notice setting for Ride Share rides lets us know how far in advance we should request a Ride Share ride for patients. For a large city we recommend the default time period of 5 minutes. For suburban and rural areas we recommend changing this to at least 15 minutes.
        </p>
      </div>
    </div>

    <div class="row mb-3">
      <label for="service_phone_number" class="fw-bold col-sm-3 col-form-label">Client Specific Service Phone Number</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" formControlName="service_phone_number">
        @if ((newHospitalForm.get('service_phone_number').touched || formInvalid) && newHospitalForm.get('service_phone_number').invalid) {
          <div class="form-error">
            <p>Service phone number cannot be empty.</p>
          </div>
        }
      </div>
    </div>

    <div class="row mb-3">
      <label for="customer_id" class="fw-bold col-sm-3 col-form-label">Customer</label>
      <div class="col-sm-9">
        <select class="form-control" formControlName="customer_id">
          <option [ngValue]="null">None</option>
          @for (customer of customers; track customer) {
            <option [value]="customer.id">
              {{customer.name}}
            </option>
          }
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <label for="hospital_id" class="fw-bold col-sm-3 col-form-label">Parent Organization</label>
      <div class="col-sm-9">
        <select class="form-control" formControlName="parent_id">
          @for (h of parentHospitals; track h) {
            <option [value]="h.id">
              {{h.name}}
            </option>
          }
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <label class="fw-bold col-sm-3 col-form-label">Organization Type</label>
      <div class="col-sm-9">
        <select class="form-control" formControlName="organization_type">
          @for (type of organizationTypeOptions; track type) {
            <option [value]="type.id">
              {{type.name}}
            </option>
          }
        </select>
        @if ((newHospitalForm.get('organization_type').touched || formInvalid) && newHospitalForm.get('organization_type').invalid) {
          <div class="form-error">
            <p>Organization type cannot be empty.</p>
          </div>
        }
      </div>
    </div>

    <div class="row mb-3">
      <label class="fw-bold col-sm-3 col-form-label">Payer Types</label>
      <div class="col-sm-9">
        <angular2-multiselect
          formControlName="payer_types"
          [data]="payerTypesList"
          [settings]="payerTypeSettings"
          (onDeSelect)="onPayerItemDeSelect($event)"
          (onDeSelectAll)="onPayerDeSelectAll()"
          >
          <c-item>
            <ng-template let-item="item">
              <label [ngClass]="{'disabled-option': item['required']}">{{item.itemName}}</label>
            </ng-template>
          </c-item>
        </angular2-multiselect>
        @if ((newHospitalForm.get('payer_types').touched || formInvalid) && newHospitalForm.get('payer_types').invalid) {
          <div class="form-error">
            <p>Please select at least one payer type.</p>
          </div>
        }
      </div>
    </div>

    <div class="row mb-3">
      <label for="hospital_id" class="fw-bold col-sm-3 col-form-label">Password Expiration</label>
      <div class="col-sm-9">
        <div class="row">
          <div class="col col-sm-6">
            <input class="form-control" type="number" formControlName="password_expiration_interval">
          </div>
          <div class="col col-sm-6">
            <select class="form-control" formControlName="password_expiration_interval_type">
              <option value="day">Day(s)</option>
              <option value="week">Week(s)</option>
              <option value="year">Year(s)</option>
            </select>
          </div>
          @if ((newHospitalForm.get('password_expiration_interval').touched ||
            newHospitalForm.get('password_expiration_interval_type').touched || formInvalid) &&
            newHospitalForm.get('password_expiration_interval').invalid ||
            newHospitalForm.get('password_expiration_interval_type').invalid) {
            <div class="col col-sm-12 form-error"
              >
              <p>Invalid expiration period.</p>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <label class="fw-bold col-sm-3 col-form-label">User Session Timeout</label>
      <div class="col-sm-9">
        <input type="number" class="form-control" formControlName="user_timeout_interval">
        @if ((newHospitalForm.get('user_timeout_interval').invalid || formInvalid) && newHospitalForm.get('user_timeout_interval').invalid) {
          <div class="form-error">
            @if (newHospitalForm.get('user_timeout_interval').errors?.min) {
              <p>The value should be greater than or equal to 15.</p>
            }
            @if (newHospitalForm.get('user_timeout_interval').errors?.max) {
              <p>The value should be less than or equal to 480.</p>
            }
          </div>
        }
        <p class="small">
          Please enter a value in minutes.
        </p>
      </div>
    </div>

    <div class="row mb-3">
      <label for="name" class="fw-bold col-sm-3 col-form-label">Enabled Vehicles</label>
      <div class="col-sm-9">
        <angular2-multiselect [data]="vehicleList" [(ngModel)]="selectedVehicles"
          [settings]="vehicleDropDownSettings"
          (onSelect)="onVehicleItemSelect($event)"
          (onDeSelect)="OnVehicleItemDeSelect($event)"
          formControlName="enabled_vehicles">
        </angular2-multiselect>
        @if ((newHospitalForm.get('enabled_vehicles').dirty || formInvalid) && newHospitalForm.get('enabled_vehicles').invalid) {
          <div class="form-error">
            <p>Please select at least one option.</p>
          </div>
        }
      </div>
    </div>

    <div class="row mb-3">
      <label class="fw-bold col-sm-3 col-form-label">Unit of Measurement</label>
      <div class="col-sm-9">
        <select class="form-control" formControlName="measurement_unit">
          @for (type of measurementUnitOptions; track type; let i = $index) {
            <option [value]="type.id">
              {{type.name}}
            </option>
          }
        </select>
        @if ((newHospitalForm.get('measurement_unit').touched || formInvalid) && newHospitalForm.get('measurement_unit').invalid) {
          <div class="form-error">
            <p>Unit of Measurement cannot be empty.</p>
          </div>
        }
      </div>
    </div>

    <div class="row mb-3">
      <label class="fw-bold col-sm-3 col-form-label">Auto-Assign Transport Company</label>
      <div class="col-sm-9">
        <select class="form-control" formControlName="autoassign_company_id">
          <option value="" selected="selected">--Select--</option>
          @for (provider of activeProviders; track provider) {
            <option [value]="provider.id">
              {{ provider.name }}
            </option>
          }
        </select>
        <p class="small">
          All eligible rides booked with a vehicle type available at the selected transport company will bypass the Community and be automatically assigned to that transport company.
        </p>
      </div>
    </div>

    <div class="row mb-3">
      <label class="fw-bold col-sm-3 col-form-label">Trip Reasons</label>
      <div class="col-sm-9">
        <angular2-multiselect [data]="reasonTypesList" [(ngModel)]="selectedReasonTypes"
          [settings]="reasonTypesDropDownSettings"
          (onSelect)="onReasonItemSelect($event)"
          (onDeSelect)="OnReasonItemDeSelect($event)"
          formControlName="reason_types">
        </angular2-multiselect>
        @if ((newHospitalForm.get('reason_types').dirty || formInvalid) && newHospitalForm.get('reason_types').invalid) {
          <div class="form-error">
            <p>Please select at least one option.</p>
          </div>
        }
      </div>
    </div>

    <div class="row mb-3">
      <label class="fw-bold col-sm-3 col-form-label">Email Offer Text</label>
      <div class="col-sm-9">
        <textarea class="form-control" formControlName="email_offer_text" rows="5" placeholder="You are eligible for two free rides through the Facility program.">
        </textarea>
      </div>
    </div>

    <div class="row mb-3">
      <label class="fw-bold col-sm-3 col-form-label">Send Will Call Ready Text?</label>
      <div class="col-sm-9">
        <ui-switch id="will_call" name="will_call" formControlName="send_will_call_text"></ui-switch>
      </div>
    </div>

    <div class="row mb-3">
      <label class="fw-bold col-sm-3 col-form-label">Disabled PCS?</label>
      <div class="col-sm-9">
        <ui-switch id="pcs_disabled" name="pcs_disabled" formControlName="pcs_disabled"></ui-switch>
      </div>
    </div>

    <div class="row mb-3">
      <label class="fw-bold col-sm-3 col-form-label">Address</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" placeholder="Address" formControlName="address">
      </div>
    </div>

    <div class="row mb-3">
      <label class="fw-bold col-sm-3 col-form-label">Tax ID</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" placeholder="xx-xxxxxxx" formControlName="tax_id">
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-default" (click)="modalRef.hide()">Close</button>
  <button type="button" class="btn btn-primary" (click)="addHospital()" [disabled]="formInvalid && newHospitalForm.invalid">Save Changes</button>
</div>
